import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IRegisterReducer } from 'core/slices/register';

const sessionAttemptId = (state: RootState) => state.state[EntityTypes.SESSION_ATTEMPT];
const register = (state: RootState) => state.register;

export const selectSessionAttempt = createSelector(
  [sessionAttemptId, register],
  (sessionAttemptId: number, register: IRegisterReducer) => {
    return register.attempts[sessionAttemptId];
  },
);
